import React from 'react';
// import { Link } from 'gatsby';

interface CustomLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  isLink?: boolean;
  href: string;
  children: React.ReactNode;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function CustomLink({ isLink, href, children, ...props }: CustomLinkProps) {
  /* if (isLink) {
    return (
      <Link
        to={href}
        {...props}>
        {children}
      </Link>
    );
  } */

  return (
    <a
      href={href}
      {...props}>
      {children}
    </a>
  );
}

export default CustomLink;
